<template lang="pug">
  footer.mt-12
    .footer-goto(v-if="this.$route.path !== '/kontakt'")
      .footer-goto-wrap.container
        .goto <span>Sie haben Fragen?</span> <router-link class="btn" to="/kontakt">zum Kontaktformular</router-link>

    transition(name="fade")
      div#to-top(@click="toTop" v-if="scY > 50")
        font-awesome-icon(icon="angle-up")

    .footer-wrap.container.mx-auto
      div.logo
        img(src="@/assets/footer_logo.png")
      .address
       p Campus <strong>& College</strong> ist eine Marke der NEW G.O.L. GmbH <br> Grünewaldstraße 49—51 | D-63834 Sulzbach am Main/Germany<br> <a href="mailto:info@campus-und-college.de">info@campus-und-college.de</a> | <a href="https://campus-und-college.de">www.campus-und-college.de</a>
    .copyright
      .copyright-wrap.container
        div.company © {{ new Date().getFullYear() }} Campus <strong>& College</strong> ist eine Marke der NEW G.O.L. GmbH
        div.footer-menu
          Menu#footer-menu(k="footer-menu" :max-depth="1")
</template>

<script>
import { mapGetters } from 'vuex';

import Menu from '@/components/Menu.vue';

export default {
    name: 'Footer',
    components: {
        Menu
    },
    data() {
        return {
            scTimer: 0,
            scY: 0
        };
    },
    computed: {
        ...mapGetters({
            menus: 'menus',
            config: 'config'
        })
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
    },

    methods: {
        handleScroll: function() {
            if (this.scTimer) return;
            this.scTimer = setTimeout(() => {
                this.scY = window.scrollY;
                clearTimeout(this.scTimer);
                this.scTimer = 0;
            }, 100);
        },
        toTop: function() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    }
};
</script>

<style lang="sass" nolang="scss" scoped>
@import "~@/assets/sass/variables"

footer
  @apply hidden
  @screen lg
    @apply block bottom-0 w-full text-white
    background: $cc-blue
    font-family: $font-alternative

  .footer-goto
    background-color: $cc-grey
    &:before
      @apply ml-auto mr-auto left-0 right-0 absolute
      border-left: 10px solid transparent
      border-right: 10px solid transparent
      border-top: 10px solid #fff
      content: ''
      height: 10px
      width: 10px
      margin: 0 auto 33px auto

    .footer-goto-wrap
      @apply mx-auto flex justify-center items-center font-bold
      color: $cc-font-base
      padding: 42px 0px 36px 0px
      font-size: 28px
      line-height: 26px

      .btn
        @apply text-white font-bold uppercase inline-block relative transition duration-500 ease-in-out
        font-family: $font
        background-color: $cc-green
        top: -3px
        box-shadow: 0 -3px rgba(0,0,0,0.1) inset
        font-size: 12px
        letter-spacing: 2px
        margin-left: 20px
        line-height: 24px
        padding: 16px 21px
        &:hover
          @apply opacity-75

  .footer-wrap
    @apply flex relative items-start font-light
    padding: 55px 0

    strong
      @apply font-bold
    a
      @apply transition duration-500 ease-in-out
      &:hover
        color: $cc-green
    .logo
      margin-right: 30px
      > img
        max-width: 75px
    .address
      margin-right: 4rem


  .copyright
    @apply flex justify-center items-center
    background: $cc-green
    border-top: 1px solid rgba(255,255,255,0.18)
    color: #1a2541
    font-size: 12px
    min-height: 66px
    a
      @apply transition duration-500 ease-in-out
      &:hover
        @apply text-white
    .copyright-wrap
      @apply flex justify-center items-center mx-auto
      .footer-menu
        margin-left: auto
        color: $cc-blue
        font-size: 12px
        &::v-deep
          .tree-menu > li
            display: inline-block
            margin-left: 15px
            a
              @apply transition duration-500 ease-in-out uppercase
              &:hover
                @apply text-white

  div#to-top
    @apply fixed text-center transition duration-500 ease-in-out cursor-pointer bg-black bg-opacity-75
    width: 29px
    height: 29px
    line-height: 29px
    bottom: 17px
    right: 17px
    z-index: 200
    &:hover
      background-color: $cc-green
      outline: 1px solid #fff

  .fade-enter,
  .fade-leave-to
    opacity: 0

  .fade-enter-active,
  .fade-leave-active
    transition: opacity .5s
</style>
